// extracted by mini-css-extract-plugin
module.exports = {"media":"Media_media__29ca_","controls":"Media_controls__1_TzJ","flex":"Media_flex__2EPvq","disabled":"Media_disabled__2NgZx","actions":"Media_actions__1BqE1"};